"use client";

import { Accordion, AccordionItem } from "@heroui/react";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqAccordionProps {
  faqs: FaqItem[];
}

const FaqAccordion = ({ faqs }: FaqAccordionProps) => {
  return (
    <Accordion
      className="max-w-3xl mx-auto"
      itemClasses={{
        title: " font-medium text-lg/[28px] text-textf1",
        base: "py-3 md:py-5",
        content: "pt-0",
        trigger: "pb-3",
      }}
    >
      {faqs.map((item, index) => (
        <AccordionItem
          key={index}
          aria-label={item.question}
          indicator={({ isOpen }) =>
            isOpen ? (
              <FiMinusCircle className="text-silverBlue h-6 w-6 rotate-90 cursor-pointer" />
            ) : (
              <FiPlusCircle className="text-silverBlue h-6 w-6 cursor-pointer" />
            )
          }
          title={<h4>{item.question}</h4>}
        >
          <div className="text-textf2">{item.answer}</div>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default FaqAccordion;
